// 物件一覧 簡易編集モーダル
const ModalPropertyQuickEdit = {
  namespaced: true,

  state: {
    modal: false,
    id: null,
    mBTypeId: null,
    type: 'residence',
    formItem: {
      b_price_low: null,
      management_fee: null,
      repair_reserve_cost: null,
      mi_transaction_form_cd: null,
      confirm_y: null,
      confirm_m: null,
      confirm_d: null,
      mi_sale_state_cd: null,
      m_vacant_type_id: null,
      closed_info: '',
      free_tag_1: '',
      free_tag_2: '',
      free_tag_3: '',
      free_tag_4: '',
      free_tag_5: '',
      yield: null,
      income_price: null,
    },
  },

  getters: {
    getModal: state => state.modal,
    getId: state => state.id,
    getMBTypeId: state => state.mBTypeId,
    getType: state => state.type,
    getFormItem: state => state.formItem,
  },

  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setId(state, id) {
      state.id = id
    },
    setMBTypeId(state, mBTypeId) {
      state.mBTypeId = mBTypeId
    },
    setType(state, type) {
      state.type = type
    },
    setFormItem(state, formItem) {
      state.formItem = formItem
    },
  },

  actions: {
    set({ commit }, { item, type }) {
      const formItem = {
        b_price_low: item.b_price_low,
        management_fee: item.management_fee,
        repair_reserve_cost: item.repair_reserve_cost,
        mi_transaction_form_cd: item.mi_transaction_form_cd,
        confirm_y: item.confirm_y,
        confirm_m: item.confirm_m,
        confirm_d: item.confirm_d,
        mi_sale_state_cd: item.mi_sale_state_cd,
        m_vacant_type_id: item.m_vacant_type_id,
        closed_info: item.closed_info || '',
        free_tag_1: item.free_tag_1 || '',
        free_tag_2: item.free_tag_2 || '',
        free_tag_3: item.free_tag_3 || '',
        free_tag_4: item.free_tag_4 || '',
        free_tag_5: item.free_tag_5 || '',
        yield: item.yield,
        income_price: item.income_price,
      }
      commit('setFormItem', formItem)
      commit('setMBTypeId', item.m_b_type_id)
      commit('setType', type || 'residence')
      commit('setId', item.id)
      commit('setModal', true)
    },
    reset({ commit }) {
      commit('setModal', false)
      commit('setId', null)
      commit('setMBTypeId', null)
      commit('setType', 'residence')
      commit('setFormItem', {
        b_price_low: null,
        management_fee: null,
        repair_reserve_cost: null,
        mi_transaction_form_cd: null,
        confirm_y: null,
        confirm_m: null,
        confirm_d: null,
        mi_sale_state_cd: null,
        m_vacant_type_id: null,
        closed_info: '',
        free_tag_1: '',
        free_tag_2: '',
        free_tag_3: '',
        free_tag_4: '',
        free_tag_5: '',
        yield: null,
        income_price: null,
      })
    },
  },
}

export default ModalPropertyQuickEdit
